module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/calculator/calculator-item/business-calculator/fleet/fleet-boat/fleet-boat.component.css
// module id = ./src/app/components/calculator/calculator-item/business-calculator/fleet/fleet-boat/fleet-boat.component.css
// module chunks = main